// extracted by mini-css-extract-plugin
export default {"imageWrapper":"PG-z","twoColumnImage":"QG-z"};